/**
 * The little type system everything that reads a MIC label shares.
 *
 * Two rules, and they are the whole visual identity of the feature:
 *
 *   - a label CODE is set in monospace. These strings are machine-printed on a tag and read off it
 *     under a machine light: even digit widths are what let an operator tell RM-000412 from RM-000142
 *     at a glance, which a proportional face actively works against. It applies to the field a code is
 *     typed into as much as to the card it comes back on.
 *   - everything that names a KIND of thing, or the state of the reader, is set as an eyebrow: small,
 *     wide-tracked, uppercase by CSS so the text itself stays translatable and searchable exactly as
 *     Sun and the dictionary spell it.
 *
 * In generic/qr because the same element is described in more than one place — the reading dialog, the
 * widget's last read, the element's card — and the three must read as the same object.
 */

export const EYEBROW_SX = {
  fontSize: '0.65rem',
  fontWeight: 700,
  lineHeight: 1.3,
  letterSpacing: '0.09em',
  textTransform: 'uppercase',
  color: 'text.secondary'
}

const CODE_FONT_FAMILY = 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace'

/** @param {string} fontSize the code's size at this scale — a widget card is smaller than a dialog. */
export const codeSx = (fontSize) => ({
  fontFamily: CODE_FONT_FAMILY,
  fontWeight: 700,
  fontSize,
  letterSpacing: '0.02em',
  lineHeight: 1.25
})
